import "@babel/polyfill";
export { domStart } from "./DOM/domStart";